"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsorted = exports.desc = exports.asc = exports.TABLE_VIEW = exports.TREE_VIEW = exports.SHOW_SELECTED = exports.SHOW_ALL = exports.recursivePropName = exports.defaultIconSize = exports.tooltipText = exports.TreeClass = exports.TreeNodeClasses = void 0;
var TreeNodeClasses = {
  container: 'tree-view-node-container',
  treeNodeContent: 'tree-view-node-content',
  parentNodeContainer: 'tree-view-node-parent-node-container',
  parentNodeContainerRemovePadding: 'tree-view-node-parent-node-container-remove-padding',
  parentNodeContainerSingleEnvironmentSelect: 'tree-view-node-parent-node-container-single-environment-select',
  parentNodeContainerSingleEnvironmentSelectChecked: 'tree-view-node-parent-node-container-single-environment-select-checked',
  parentContainer: 'tree-view-node-parent-container',
  parentContainerRemovePadding: 'tree-view-node-parent-container-remove-padding',
  parentIcon: 'tree-view-node-parent-icon',
  parentText: 'tree-view-node-parent-text',
  nodeIcon: 'tree-view-node-icon',
  nodeIconCursor: 'tree-view-node-icon-cursor-pointer',
  nodeLeftemptyPadding: 'tree-view-node-left-empty-padding',
  tableNameCellContent: 'tree-view-table-name-cell-content',
  dirIconContainer: 'tree-view-node-dir-icon',
  disabledRow: 'tree-view-node-disabled'
};
exports.TreeNodeClasses = TreeNodeClasses;
var TreeClass = {
  boundingContainer: 'tree-view-bounding-container',
  container: 'tree-view-container',
  filterContainer: 'tree-view-filter-container',
  filterContainerWithoutDropdown: 'tree-view-filter-container-without-dropdown'
};
exports.TreeClass = TreeClass;
var tooltipText = {
  list: 'List View',
  tree: 'Tree View'
};
exports.tooltipText = tooltipText;
var defaultIconSize = 24;
exports.defaultIconSize = defaultIconSize;
var recursivePropName = 'nodes';
exports.recursivePropName = recursivePropName;
var SHOW_ALL = 'Show All';
exports.SHOW_ALL = SHOW_ALL;
var SHOW_SELECTED = 'Show Selected';
exports.SHOW_SELECTED = SHOW_SELECTED;
var TREE_VIEW = 'tree';
exports.TREE_VIEW = TREE_VIEW;
var TABLE_VIEW = 'table';
exports.TABLE_VIEW = TABLE_VIEW;
var asc = 'ascending';
exports.asc = asc;
var desc = 'descending';
exports.desc = desc;
var unsorted = 'unsorted';
exports.unsorted = unsorted;